import Image from "@components/Image";
import React from "react";
import styles from "./Exploration.module.scss";
import cx from "classnames";
import { useTranslationContext } from "@providers/TranslationProvider";
import Button from "@components/Button";
import Link from "@components/Link";
import _ from "lodash";
import { useRouteContext } from "@providers/RouteProvider";

interface IProps {
  data: {
    image: { src: string; alt: string };
    title: string | React.ReactNode;
    topic: string | React.ReactNode;
    slug: string;
    description: string | React.ReactNode;
    hideReadMore?: boolean;
  };
}

export default function Item({ data }: IProps) {
  const { i18n } = useTranslationContext();
  const { router } = useRouteContext();
  return (
    <Link href={router.toUrl("storiesArticle", { slug: data.slug })}>
      <div className={cx("flex flex-col", styles.item)}>
        <Image
          wrapperProps={{ className: cx(styles.image) }}
          // className={cx(styles.image)}
          {..._.get(data, "image")}
          alt={_.get(data, "image.alt") || data.title?.toString() || "Exploration item"}
          layout="fill"
        />
        <div className="flex flex-col gap-2 mt-6">
          <div className={cx(styles.tag)}>{data.topic}</div>
          <div className={cx(styles.title)}>{data.title}</div>
          <div className={cx("text-ellipsis-10", styles.content)}>
            {data.description}
          </div>
        </div>
        {!data?.hideReadMore && (
          <Button
            type="icon"
            suffix="shape-arrow"
            className={cx(styles.readMore, "mt-auto")}
            label={i18n.t("Button.readMore")}
          />
        )}
      </div>
    </Link>
  );
}
